import React, { Component } from 'react';
import '../../Modal.css';
import { connect } from 'react-redux';
import { updateSelectedProgram } from '../../../../actions/adminActions/programsActions';
import { programs } from '../../../../apis/backend';

class EditModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      id: '',
      name: ''
    };
  }

  clearState() {
    this.setState({
      id: '',
      name: ''
    });
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (
      prevProps.selectedProgram !== this.props.selectedProgram &&
      this.props.selectedProgram !== 0
    ) {
      const program = this.props.programs.find((obj) => obj.id === this.props.selectedProgram);
      if (program) {
        this.setState({
          name: program.name
        });
      }
    }
  }

  async programRequest() {
    try {
      await programs
        .patch(
          `/${this.props.selectedProgram}`,
          {
            name: this.state.name
          },
          { headers: { authorization: this.props.employeeToken } }
        )
        .then(this.clearState())
        .catch((response) => {
          console.log(response);
          alert('Sorry, an error occurred. Please check your entries.');
        });
    } catch (err) {
      console.log('Request Failed.');
    }
  }

  render() {
    return (
      <div id="exampleModal" className="modal fade" style={{ overflow: 'scroll' }}>
        <div className="modal-dialog modal-dialog-centered lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Update Program</h5>
              <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="input-group input-group-sm mb-3">
                <div className="input-group-prepend">
                  <span className="input-group-text" id="inputGroup-sizing-sm">
                    Program Name
                  </span>
                </div>
                <input
                  type="text"
                  className="form-control"
                  aria-label="Sizing example input"
                  aria-describedby="inputGroup-sizing-sm"
                  value={this.state.name}
                  onChange={(e) => this.setState({ name: e.target.value })}
                />
              </div>
            </div>

            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-dismiss="modal"
                onClick={() => this.clearState()}
              >
                Cancel
              </button>
              <button
                type="button"
                className="btn btn-dark"
                data-dismiss="modal"
                onClick={() => {
                  this.programRequest();
                }}
                disabled={!this.state.name != ''}
              >
                Save changes
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  programs: state.admin.admin.programs,
  selectedProgram: state.admin.programs.selectedProgram,
  employeeToken: state.auth.employeeToken
});

export default connect(mapStateToProps, { updateSelectedProgram })(EditModal);
